import React from "react";
import styled from "styled-components";
import LazyLoad from "react-lazyload";
import { Helmet } from "react-helmet";
import CTASection from "../../components/CTASection";
import SponsorCarousel from "../../components/SponsorCarousel";
import sponsorshipImage from "../../assets/images/volunteer/construction.webp";
import DynamicEvents from "../../components/DynamicEvents";

const SponsorshipPackages = () => {
  return (
    <>
      <Helmet>
        <title>Sponsorship Packages - Habitat for Humanity Buffalo</title>
        <meta
          name="description"
          content="Discover sponsorship packages with Habitat for Humanity Buffalo. Help build affordable homes by sponsoring a build day or an entire house."
        />
      </Helmet>
      <Container>
        <div className="text-center">
          <h1>Sponsorship Packages</h1>
          <LazyLoad height={200} offset={100}>
            <HeaderImage
              src={sponsorshipImage}
              alt="Sponsorship Opportunities"
              loading="lazy" // Add loading attribute for optimization
            />
          </LazyLoad>
          <h2 className="section-header primary">
            Build Homes, Build Hope with Your Sponsorship
          </h2>
        </div>
        <Section>
          <p>
            Habitat for Humanity Buffalo relies on the support of generous
            sponsors to provide affordable housing solutions for families in
            need. Sponsorship opportunities range from a dedicated build day to
            full house sponsorship. Each sponsorship tier includes unique perks
            for your organization and demonstrates your commitment to building a
            better future for Buffalo.
          </p>
          <p>
            By sponsoring a project, your organization helps us offset the costs
            of construction materials, labor, and the mortgage subsidy for each
            homeowner, ensuring that they can afford their new home. With
            several sponsorship levels, there's a perfect fit for every
            organization.
          </p>
        </Section>
        <Section>
          <SectionHeader color="green" role="heading" aria-level="2">
            Sponsorship Tiers for Every Organization
          </SectionHeader>
          <p>
            Our sponsorship tiers include a range of options, from sponsoring a
            single build day to becoming a house sponsor. Each tier comes with
            benefits, such as branded signage at build sites, recognition on our
            website and social media, and the opportunity for your employees to
            engage in team builds.
          </p>
          <p>
            Whether you're a small business looking to give back or a large
            corporation seeking a meaningful partnership, we have the right
            package for you. Contact us today to receive our comprehensive
            sponsorship package and find out how your organization can make a
            lasting impact.
          </p>
        </Section>
        <CTASection
          title="Request Our Sponsorship Package"
          description="Interested in learning more? Fill out our interest form to receive our sponsorship package and find the right opportunity for your organization."
          buttonText="Get Sponsorship Info"
          buttonLink="/form/sponsorship"
        />
        <DynamicEvents category="sponsors" categoryText="Sponsors" />
        <SponsorCarousel />
      </Container>
    </>
  );
};

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;

const HeaderImage = styled.img`
  width: 100%;
  max-width: 600px;
  margin: 20px 0;
  border-radius: 8px;
`;

const Section = styled.div`
  margin-bottom: 40px;
`;

const SectionHeader = styled.h2`
  text-align: center;
  background-color: ${(props) => props.color || "var(--primary-color)"};
  color: white;
  padding: 10px;
  border-radius: 5px;
`;

export default SponsorshipPackages;
